import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { ieSteps } from '../../../util/IEUtils';

const IEStepHeader = ({ activeStep, steps, currentStep, onStepChange }) => {
  if (activeStep === ieSteps.SURVEY_DETAILS) {
    return (
      <header className="ie--header">
        <div className="ie--steps">
          <span className="ie--steps--name ie--steps--active">
            Survey Details
          </span>
        </div>
      </header>
    );
  }
  return (
    <header className="ie--header">
      <div className="ie--steps">
        {steps.map((label, index) => (
          <div key={label}>
            <button
              className={`ie--steps--name ${currentStep === index ? 'ie--steps--active' : ''}`}
              onClick={() => onStepChange(index)}
              disabled={index > currentStep}
              type="button"
            >
              {label}
            </button>
          </div>
        ))}
      </div>
    </header>
  );
};

IEStepHeader.propTypes = {
  activeStep: PropTypes.string,
  steps: PropTypes.instanceOf(Array),
  currentStep: PropTypes.number,
  onStepChange: PropTypes.func,
};

IEStepHeader.defaultProps = {
  activeStep: ieSteps.SURVEY_SETTINGS,
  steps: ['Survey Settings', 'Target', 'Questions', 'Dictionary', 'Summary'],
  currentStep: 0,
};

const mapStateToProps = state => ({
  activeStep: state.turnkeyOmnibus.activeStep,
});

export default connect(
  mapStateToProps,
  null
)(IEStepHeader);
